<app-page-header></app-page-header>
<app-breadcromb pageName="View Document"></app-breadcromb>
<!-- Candidate Dashboard Area Start -->
<section class="candidate-dashboard-area section_70">
  <div class="container">
    <div class="row">
      <div class="col-lg-3 col-md-12 dashboard-left-border">
        <div class="dashboard-left">
          <app-client-dashboard-sidebar></app-client-dashboard-sidebar>
        </div>
      </div>
      <div class="col-lg-9 col-md-12">
        <div class="dashboard-right">
          <div class="candidate-profile">
            <div class="candidate-single-profile-info">
              <pdf-viewer [src]="pdfSrc" [render-text]="true"></pdf-viewer>
<!--              <ngx-doc-viewer [url]="pdfSrc" viewer="url"></ngx-doc-viewer>-->
              <!--<ngx-doc-viewer
                [viewerUrl]="viewUrl"
                [url]="pdfSrc"
                viewer="url" style="width:100%;height:50vh;">
              </ngx-doc-viewer>-->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- Candidate Dashboard Area End -->
